import { CButton, CButtonGroup, CTooltip } from "@coreui/react";
import WebhookEndpoint from "../../models/webhook-endpoint";

interface WebhookEndpointCrudActionsProps {
  endpoint: WebhookEndpoint;
  onEditClick: (_: WebhookEndpoint) => void;
  onDeleteClick: (_: WebhookEndpoint) => void;
  onViewEventsClick: (_: WebhookEndpoint) => void;
  onTestClick: (_: WebhookEndpoint) => void;
  testingEndpointId?: number;
}

const WebhookEndpointCrudActions: React.FC<WebhookEndpointCrudActionsProps> = ({
  endpoint,
  onEditClick,
  onDeleteClick,
  onViewEventsClick,
  onTestClick,
  testingEndpointId,
}) => {
  return (
    <td className="text-center">
      <CButtonGroup>
        <CTooltip content={"Ver eventos"}>
          <CButton
            color="info"
            className="text-white"
            onClick={() => onViewEventsClick(endpoint)}
          >
            <i className="fa fa-list"></i>
          </CButton>
        </CTooltip>
        <CTooltip content={"Enviar evento de prueba"}>
          <CButton
            color="success"
            className="text-white"
            disabled={testingEndpointId === endpoint.id}
            onClick={() => onTestClick(endpoint)}
          >
            <i className="fa fa-paper-plane"></i>
          </CButton>
        </CTooltip>
        <CTooltip content={"Editar"}>
          <CButton
            color="warning"
            className="text-white"
            onClick={() => onEditClick(endpoint)}
          >
            <i className="fa fa-pencil"></i>
          </CButton>
        </CTooltip>
        <CTooltip content={"Eliminar"}>
          <CButton
            color="danger"
            className="text-white"
            onClick={() => onDeleteClick(endpoint)}
          >
            <i className="fa fa-trash"></i>
          </CButton>
        </CTooltip>
      </CButtonGroup>
    </td>
  );
};

export default WebhookEndpointCrudActions;
